import { apiGet, apiPost } from './apiClient.js';

/**
 * Admin API Keys Service
 * For managing admin API keys (not integration-specific)
 */

/**
 * List all admin API keys
 * @param {boolean} includeRevoked - Include revoked keys
 */
export async function listAdminApiKeys(includeRevoked = false) {
  const params = includeRevoked ? '?include_revoked=true' : '';
  return apiGet(`/admin/api-keys/admin${params}`);
}

/**
 * Get single admin API key
 * @param {string} id
 */
export async function getAdminApiKey(id) {
  return apiGet(`/admin/api-keys/admin/${id}`);
}

/**
 * Create a new admin API key
 * @param {string} name - User-friendly name
 * @param {string} reason - Reason for creation (required)
 * @param {number} intentAuditEventId - Intent audit event ID (required)
 */
export async function createAdminApiKey(name, reason, intentAuditEventId) {
  if (!name || !name.trim()) {
    throw new Error('Name is required');
  }
  if (!reason || !reason.trim()) {
    throw new Error('Reason is required');
  }
  if (!intentAuditEventId) {
    throw new Error('Intent audit event ID is required');
  }

  return apiPost('/admin/api-keys/admin', {
    name: name.trim(),
    reason: reason.trim(),
    intentAuditEventId,
  });
}

/**
 * Revoke an admin API key
 * @param {string} id - Key ID
 * @param {string} reason - Reason for revocation (required)
 * @param {number} intentAuditEventId - Intent audit event ID (required)
 */
export async function revokeAdminApiKey(id, reason, intentAuditEventId) {
  if (!reason || !reason.trim()) {
    throw new Error('Reason is required');
  }
  if (!intentAuditEventId) {
    throw new Error('Intent audit event ID is required');
  }

  return apiPost(`/admin/api-keys/admin/${id}/revoke`, {
    reason: reason.trim(),
    intentAuditEventId,
  });
}

/**
 * Rotate an admin API key
 * @param {string} id - Key ID
 * @param {string} name - Optional name for new key
 * @param {string} reason - Reason for rotation (required)
 * @param {number} intentAuditEventId - Intent audit event ID (required)
 */
export async function rotateAdminApiKey(id, name, reason, intentAuditEventId) {
  if (!reason || !reason.trim()) {
    throw new Error('Reason is required');
  }
  if (!intentAuditEventId) {
    throw new Error('Intent audit event ID is required');
  }

  const body = {
    reason: reason.trim(),
    intentAuditEventId,
  };
  if (name) {
    body.name = name.trim();
  }

  return apiPost(`/admin/api-keys/admin/${id}/rotate`, body);
}

